import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AbscondDriverList from './AbscondDriverList';
import {getAllAbscondedDrivers,releaseAbscondedDrivers,approveAbscondedDrivers} from "services/redux/Valet/Project/action";

const mapStateToProps = (state) => ({
    allAbscondDriverList: state.CreateProject.allAbscondDriverList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getAllAbscondedDrivers,
        releaseAbscondedDrivers,
        approveAbscondedDrivers
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AbscondDriverList);
